let userAgent = 'Node';
if (typeof navigator !== 'undefined') {
  userAgent = navigator.userAgent;
}

module.exports = function isiOSFactory(deps = { userAgent }) {
  return /iPhone|iPad/.test(deps.userAgent);
};
